import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, money } from "@/lib/api";

export default function OrderDetail() {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  useEffect(() => { api.get(`/me/orders/${id}`).then((r) => setOrder(r.data)).catch(() => setOrder(false)); }, [id]);
  if (order === null) return <div className="overline animate-pulse">Loading order…</div>;
  if (order === false) return <div>Order not found.</div>;
  return (
    <div>
      <Link to="/account/orders" className="overline link-underline">← Orders</Link>
      <h2 className="font-display text-3xl font-bold mt-3">Order {order.order_number}</h2>
      <div className="mt-1 text-sm text-zinc-500 font-mono">{new Date(order.created_at).toLocaleString()} · status: {order.status}</div>

      <div className="mt-8 border border-black/10">
        {order.items.map((i) => (
          <div key={i.line_id} className="p-4 flex justify-between border-b border-black/10 last:border-b-0">
            <div>
              <div className="font-display font-semibold">{i.product_name}</div>
              {i.variant_label && <div className="text-xs font-mono text-zinc-500 mt-1">{i.variant_label} · {i.variant_sku}</div>}
              <div className="text-xs mt-1">× {i.quantity}</div>
            </div>
            <div className="font-mono">{money(i.subtotal_cents)}</div>
          </div>
        ))}
      </div>

      <div className="mt-8 grid md:grid-cols-2 gap-6">
        <div className="border border-black/10 p-6">
          <div className="overline mb-3">Shipping to</div>
          <div className="text-sm">{order.shipping_address.full_name}</div>
          <div className="text-sm text-zinc-600">{order.shipping_address.line1}{order.shipping_address.line2 ? `, ${order.shipping_address.line2}` : ""}</div>
          <div className="text-sm text-zinc-600">{order.shipping_address.city}, {order.shipping_address.state} {order.shipping_address.postal_code}</div>
          <div className="text-sm text-zinc-600">{order.shipping_address.country}</div>
        </div>
        <div className="border border-black/10 p-6">
          <div className="overline mb-3">Totals</div>
          <dl>
            <div className="data-row"><dt>Subtotal</dt><dd>{money(order.subtotal_cents)}</dd></div>
            {order.discount_cents > 0 && <div className="data-row"><dt>Discount</dt><dd>-{money(order.discount_cents)}</dd></div>}
            <div className="data-row"><dt>Shipping</dt><dd>{money(order.shipping_cents)}</dd></div>
            <div className="data-row"><dt><b>Total</b></dt><dd><b>{money(order.total_cents)}</b></dd></div>
          </dl>
        </div>
      </div>
    </div>
  );
}
